// UI localization service
// Contains translations for all UI elements

/**
 * UI text localization for the entire application
 */
const uiText = {
  // Input placeholders
  inputPlaceholder: {
    en: "Ask your Scratch questions here or use the mic to speak",
    es: "Haz tus preguntas sobre Scratch aquí o usa el micrófono para hablar",
    fr: "Posez vos questions sur Scratch ici ou utilisez le micro pour parler",
    ja: "Scratchについての質問をここに入力するか、マイクを使って話してください",
    it: "Fai le tue domande su Scratch qui o usa il microfono per parlare",
    de: "Stelle deine Scratch-Fragen hier oder benutze das Mikrofon zum Sprechen",
    ro: "Pune întrebările tale despre Scratch aici sau folosește microfonul pentru a vorbi",
    pt: "Faça suas perguntas sobre Scratch aqui ou use o microfone para falar",
    ru: "Задайте свои вопросы о Scratch здесь или используйте микрофон",
    ko: "Scratch에 대한 질문을 여기에 작성하거나 마이크를 사용하세요",
    zh: "在这里输入您的Scratch问题，或使用麦克风说话",
    ar: "اطرح أسئلتك حول سكراتش هنا أو استخدم الميكروفون للتحدث",
    hi: "अपने Scratch प्रश्न यहां पूछें या बोलने के लिए माइक का उपयोग करें",
    da: "Stil dine Scratch-spørgsmål her, eller brug mikrofonen"
  },
  
  // Button text
  buttonText: {
    // Create Image button
    createImage: {
      en: "Create Image",
      es: "Crear Imagen",
      fr: "Créer Image",
      ja: "画像を作成",
      it: "Crea Immagine",
      de: "Bild erstellen",
      ro: "Creează Imagine",
      pt: "Criar Imagem",
      ru: "Создать Изображение",
      ko: "이미지 생성",
      zh: "创建图像",
      ar: "إنشاء صورة",
      hi: "छवि बनाएं",
      da: "Lav Billede"
    },
    
    // Ask Question button
    askQuestion: {
      en: "Ask Question",
      es: "Hacer Pregunta",
      fr: "Poser Question",
      ja: "質問する",
      it: "Fai Domanda",
      de: "Frage stellen",
      ro: "Pune Întrebare",
      pt: "Fazer Pergunta",
      ru: "Задать Вопрос",
      ko: "질문하기",
      zh: "提问",
      ar: "اسأل سؤال",
      hi: "प्रश्न पूछें",
      da: "Stil Spørgsmål"
    },
    
    // Change Language button
    changeLanguage: {
      en: "Change Language",
      es: "Cambiar Idioma",
      fr: "Changer Langue",
      ja: "言語を変更",
      it: "Cambia Lingua",
      de: "Sprache ändern",
      ro: "Schimbă Limba",
      pt: "Mudar Idioma",
      ru: "Изменить Язык",
      ko: "언어 변경",
      zh: "更改语言",
      ar: "تغيير اللغة",
      hi: "भाषा बदलें",
      da: "Skift Sprog"
    },
    
    // Save button (for images)
    save: {
      en: "Save",
      es: "Guardar",
      fr: "Enregistrer",
      ja: "保存",
      it: "Salva",
      de: "Speichern",
      ro: "Salvează",
      pt: "Salvar",
      ru: "Сохранить",
      ko: "저장",
      zh: "保存",
      ar: "حفظ",
      hi: "सेवानिर्माण",
      da: "Gem"
    },
    
    // Microphone states
    startListening: {
      en: "Start Listening",
      es: "Comenzar a Escuchar",
      fr: "Commencer l'Écoute",
      ja: "聴き始める",
      it: "Inizia ad Ascoltare",
      de: "Zuhören beginnen",
      ro: "Începe Ascultarea",
      pt: "Iniciar Escuta",
      ru: "Начать Прослушивание",
      ko: "듣기 시작",
      zh: "开始录音",
      ar: "بدء الاستماع",
      hi: "सुनना शुरू करें",
      da: "Start Lytning"
    },
    
    stopListening: {
      en: "Stop Listening",
      es: "Dejar de Escuchar",
      fr: "Arrêter l'Écoute",
      ja: "聴くのをやめる",
      it: "Smetti di Ascoltare",
      de: "Zuhören beenden",
      ro: "Oprește Ascultarea",
      pt: "Parar Escuta",
      ru: "Остановить Прослушивание",
      ko: "듣기 중지",
      zh: "停止录音",
      ar: "توقف عن الاستماع",
      hi: "सुनना बंद करें",
      da: "Stop Lytning"
    }
  },
  
  // Drop area text
  dropAreaText: {
    en: "paste images of scratch code here",
    es: "pega imágenes del código de Scratch aquí",
    fr: "collez les images du code Scratch ici",
    ja: "Scratchコードの画像をここに貼り付け",
    it: "incolla qui le immagini del codice Scratch",
    de: "Bilder von Scratch-Code hier einfügen",
    ro: "lipește imaginile codului Scratch aici",
    pt: "cole imagens do código Scratch aqui",
    ru: "вставьте изображения кода Scratch здесь",
    ko: "Scratch 코드 이미지를 여기에 붙여넣으세요",
    zh: "在此处粘贴Scratch代码图像",
    ar: "الصق صور كود سكراتش هنا",
    hi: "Scratch कोड की छवियां यहां चिपकाएं",
    da: "indsæt billeder af Scratch-kode her"
  },
  
  // Image Generation Command Prefix
  // Supports both English command for compatibility AND localized commands in each language
  generateImageCommand: {
    en: ["generate image"],
    es: ["generate image", "crear imagen", "generar imagen"],
    fr: ["generate image", "créer image", "générer image"],
    ja: ["generate image", "画像作成", "画像生成"],
    it: ["generate image", "crea immagine", "genera immagine"],
    de: ["generate image", "bild erstellen", "bild generieren"],
    ro: ["generate image", "creează imagine", "generează imagine"],
    pt: ["generate image", "criar imagem", "gerar imagem"],
    ru: ["generate image", "создать изображение", "сгенерировать изображение"],
    ko: ["generate image", "이미지 생성", "이미지 만들기"],
    zh: ["generate image", "创建图像", "生成图像"],
    ar: ["generate image", "إنشاء صورة", "توليد صورة"],
    hi: ["generate image", "छवि बनाएं", "छवि उत्पन्न करें"],
    da: ["generate image", "lav billede", "generer billede", "skab billede"]
  },
  
  // Image Generation Command Explanation (displayed to users)
  generateImageHelp: {
    en: "Type 'generate image cat' to create an image of a cat",
    es: "Escribe 'crear imagen gato' o 'generate image gato' para crear una imagen de un gato",
    fr: "Tapez 'créer image chat' ou 'generate image chat' pour créer une image de chat",
    ja: "'画像生成 猫' または 'generate image 猫' と入力して猫の画像を作成",
    it: "Digita 'crea immagine gatto' o 'generate image gatto' per creare un'immagine di un gatto",
    de: "Tippe 'bild erstellen Katze' oder 'generate image Katze' um ein Katzenbild zu erstellen",
    ro: "Tastează 'creează imagine pisică' sau 'generate image pisică' pentru a crea o imagine cu o pisică",
    pt: "Digite 'criar imagem gato' ou 'generate image gato' para criar uma imagem de um gato",
    ru: "Введите 'создать изображение кошка' или 'generate image кошка' для создания изображения кошки",
    ko: "'이미지 생성 고양이' 또는 'generate image 고양이'를 입력하여 고양이 이미지를 생성",
    zh: "输入 '创建图像 猫' 或 'generate image 猫' 来创建猫的图片",
    ar: "أدخل 'إنشاء صورة قطة' أو 'generate image قطة' لإنشاء صورة قطة",
    hi: "'छवि बनाएं बिल्ली' या 'generate image बिल्ली' लिखें बिल्ली की छवि बनाने के लिए",
    da: "Skriv 'lav billede kat' eller 'generate image kat' for at lave et billede af en kat"
  },
  
  // Error messages
  errorMessages: {
    // Microphone permission error
    microphonePermission: {
      en: "Please allow microphone permission to use speech recognition",
      es: "Por favor, permite el permiso del micrófono para usar el reconocimiento de voz", 
      fr: "Veuillez autoriser l'accès au microphone pour utiliser la reconnaissance vocale",
      ja: "音声認識を使用するにはマイクのアクセス許可を与えてください",
      it: "Consenti l'autorizzazione del microfono per utilizzare il riconoscimento vocale",
      de: "Bitte erlaube die Mikrofonberechtigung, um Spracherkennung zu nutzen",
      ro: "Te rugăm să permiți accesul la microfon pentru a utiliza recunoașterea vocală",
      pt: "Por favor, permit o permissão de microfone para usar a reconhecimento de voz",
      ru: "Пожалуйста, разрешите доступ к микрофону для использования распознавания речи",
      ko: "음성 인식을 사용하려면 마이크 권한을 부여하십시오",
      zh: "请允许麦克风权限以使用语音识别",
      ar: "الرجاء السماح بتمكين إذن الميكروفون لاستخدام التعرف على الكلام",
      hi: "कृपया माइक्रोफोन अनुमति दें जो कैल्पना का उपयोग करें",
      da: "Giv mikrofontilladelse for at bruge talegenkendelse"
    }
  }
};

/**
 * Get localized UI text based on the text category, type, and language code
 * @param {string} category - Main category (inputPlaceholder, buttonText, etc.)
 * @param {string} type - Specific text type within category (optional)
 * @param {string} langCode - Language code (en, es, fr, ja, etc.)
 * @returns {string} - Localized text
 */
const getLocalizedText = (category, type, langCode) => {
  try {
    const baseLangCode = langCode?.split('-')[0] || 'en';

    // If no specific type is provided, get directly from category
    if (!type) {
      return uiText[category][baseLangCode] || uiText[category].en;
    }
    
    // Otherwise get from nested structure
    return uiText[category][type][baseLangCode] || uiText[category][type].en;
  } catch (error) {
    console.warn(`Missing localization for ${category}.${type} in ${langCode}`, error);
    // Fallback to English if available
    try {
      return type ? uiText[category][type].en : uiText[category].en;
    } catch (error) {
      // Ultimate fallback
      return `Missing text: ${category}.${type}`;
    }
  }
};

// Define welcome messages for onboarding in all supported languages
const welcomeMessages = {
  en: {
    title: "👋 Welcome to Cognimates Copilot!",
    description: "I'm your AI coding assistant ready to help you with Scratch projects. Here's what I can do:",
    features: [
      "💬 Answer questions about coding concepts",
      "🎨 Generate images for your projects with 'generate image: [description]'",
      "🔍 Explain how to use Scratch blocks and features",
      "💡 Suggest project ideas and creative solutions"
    ],
    tryPrompt: "Try asking: 'How do I make a sprite move?' or 'Generate image: a friendly robot'",
    langNote: "You can change language using the globe icon above!"
  },
  da: {
    title: "👋 Velkommen til Cognimates Copilot!",
    description: "Jeg er din AI-kodeassistent, klar til at hjælpe dig med Scratch-projekter. Her er, hvad jeg kan:",
    features: [
      "💬 Besvare spørgsmål om programmeringsbegreber",
      "🎨 Generere billeder til dine projekter med 'lav billede: [beskrivelse]'",
      "🔍 Forklare, hvordan du bruger Scratch-blokke og funktioner",
      "💡 Foreslå projektidéer og kreative løsninger"
    ],
    tryPrompt: "Prøv at spørge: 'Hvordan får jeg en sprite til at bevæge sig?' eller 'Lav billede: en venlig robot'",
    langNote: "Du kan skifte sprog med globusikonet ovenfor!"
  },
  es: {
    title: "👋 ¡Bienvenido a Cognimates Copilot!",
    description: "Soy tu asistente de programación con IA listo para ayudarte con proyectos de Scratch. Esto es lo que puedo hacer:",
    features: [
      "💬 Responder preguntas sobre conceptos de programación",
      "🎨 Generar imágenes para tus proyectos con 'crear imagen: [descripción]'",
      "🔍 Explicar cómo usar bloques y funciones de Scratch",
      "💡 Sugerir ideas de proyectos y soluciones creativas"
    ],
    tryPrompt: "Intenta preguntar: '¿Cómo hago que un objeto se mueva?' o 'Crear imagen: un robot amigable'",
    langNote: "¡Puedes cambiar el idioma usando el ícono del globo arriba!"
  },
  fr: {
    title: "👋 Bienvenue sur Cognimates Copilot!",
    description: "Je suis ton assistant de codage IA prêt à t'aider avec tes projets Scratch. Voici ce que je peux faire :",
    features: [
      "💬 Répondre aux questions sur les concepts de programmation",
      "🎨 Générer des images pour tes projets avec 'créer image: [description]'",
      "🔍 Expliquer comment utiliser les blocs et fonctionnalités Scratch",
      "💡 Suggérer des idées de projets et des solutions créatives"
    ],
    tryPrompt: "Essaie de demander: 'Comment faire bouger un lutin?' ou 'Créer image: un robot amical'",
    langNote: "Tu peux changer la langue en utilisant l'icône du globe au-dessus!"
  },
  ja: {
    title: "👋 Cognimates Copilotへようこそ！",
    description: "Scratchプロジェクトを手伝うAIコーディングアシスタントです。できることは：",
    features: [
      "💬 プログラミングの概念について質問に答える",
      "🎨 '画像を作成: [説明]'でプロジェクト用の画像を生成",
      "🔍 Scratchのブロックや機能の使い方を説明",
      "💡 プロジェクトのアイデアや創造的な解決策を提案"
    ],
    tryPrompt: "例えば「スプライトを動かすにはどうすればいいですか？」や「画像を作成: フレンドリーなロボット」と聞いてみてください",
    langNote: "上のグローブアイコンで言語を変更できます！"
  },
  it: {
    title: "👋 Benvenuto a Cognimates Copilot!",
    description: "Sono il tuo assistente AI di programmazione pronto ad aiutarti con i progetti Scratch. Ecco cosa posso fare:",
    features: [
      "💬 Rispondere a domande sui concetti di programmazione",
      "🎨 Generare immagini per i tuoi progetti con 'crea immagine: [descrizione]'",
      "🔍 Spiegare come usare i blocchi e le funzionalità di Scratch",
      "💡 Suggerire idee per progetti e soluzioni creative"
    ],
    tryPrompt: "Prova a chiedere: 'Come faccio a muovere uno sprite?' o 'Crea immagine: un robot amichevole'",
    langNote: "Puoi cambiare lingua usando l'icona del globo qui sopra!"
  },
  de: {
    title: "👋 Willkommen bei Cognimates Copilot!",
    description: "Ich bin dein KI-Programmierassistent und helfe dir bei Scratch-Projekten. Das kann ich für dich tun:",
    features: [
      "💬 Fragen zu Programmierkonzepten beantworten",
      "🎨 Bilder für deine Projekte erstellen mit 'Bild erstellen: [Beschreibung]'",
      "🔍 Erklären, wie Scratch-Blöcke und -Funktionen verwendet werden",
      "💡 Projektideen und kreative Lösungen vorschlagen"
    ],
    tryPrompt: "Versuch's mit: 'Wie bewege ich eine Figur?' oder 'Bild erstellen: ein freundlicher Roboter'",
    langNote: "Du kannst die Sprache über das Globus-Symbol oben ändern!"
  },
  ro: {
    title: "👋 Bine ai venit la Cognimates Copilot!",
    description: "Sunt asistentul tău de programare AI gata să te ajut cu proiectele Scratch. Iată ce pot face:",
    features: [
      "💬 Răspund la întrebări despre concepte de programare",
      "🎨 Generez imagini pentru proiectele tale cu 'creează imagine: [descriere]'",
      "🔍 Explic cum să folosești blocurile și funcțiile Scratch",
      "💡 Sugerez idei de proiecte și soluții creative"
    ],
    tryPrompt: "Încearcă să întrebi: 'Cum fac un personaj să se miște?' sau 'Creează imagine: un robot prietenos'",
    langNote: "Poți schimba limba folosind iconița glob de deasupra!"
  },
  pt: {
    title: "👋 Bem-vindo ao Cognimates Copilot!",
    description: "Sou seu assistente de programação com IA pronto para ajudar com projetos do Scratch. Veja o que posso fazer:",
    features: [
      "💬 Responder perguntas sobre conceitos de programação",
      "🎨 Gerar imagens para seus projetos com 'criar imagem: [descrição]'",
      "🔍 Explicar como usar blocos e recursos do Scratch",
      "💡 Sugerir ideias de projetos e soluções criativas"
    ],
    tryPrompt: "Tente perguntar: 'Como faço um sprite se mover?' ou 'Criar imagem: um robô amigável'",
    langNote: "Você pode mudar o idioma usando o ícone do globo acima!"
  },
  ru: {
    title: "👋 Добро пожаловать в Cognimates Copilot!",
    description: "Я твой ИИ-помощник по программированию, готовый помочь с проектами Scratch. Вот что я могу делать:",
    features: [
      "💬 Отвечать на вопросы о концепциях программирования",
      "🎨 Создавать изображения для твоих проектов с помощью 'создать изображение: [описание]'",
      "🔍 Объяснять как использовать блоки и функции Scratch",
      "💡 Предлагать идеи проектов и творческие решения"
    ],
    tryPrompt: "Попробуй спросить: 'Как заставить спрайт двигаться?' или 'Создать изображение: дружелюбный робот'",
    langNote: "Ты можешь изменить язык, используя значок глобуса сверху!"
  },
  ko: {
    title: "👋 Cognimates Copilot에 오신 것을 환영합니다!",
    description: "저는 스크래치 프로젝트를 도와주는 AI 코딩 도우미입니다. 제가 할 수 있는 일은:",
    features: [
      "💬 프로그래밍 개념에 대한 질문에 답변",
      "🎨 '이미지 생성: [설명]'으로 프로젝트에 필요한 이미지 생성",
      "🔍 스크래치 블록과 기능 사용법 설명",
      "💡 프로젝트 아이디어와 창의적인 해결책 제안"
    ],
    tryPrompt: "이렇게 물어보세요: '스프라이트를 어떻게 움직이나요?' 또는 '이미지 생성: 친근한 로봇'",
    langNote: "위의 지구본 아이콘을 사용하여 언어를 변경할 수 있습니다!"
  },
  zh: {
    title: "👋 欢迎使用 Cognimates Copilot！",
    description: "我是你的AI编程助手，随时准备帮助你的Scratch项目。以下是我可以做的事情：",
    features: [
      "💬 回答有关编程概念的问题",
      "🎨 使用'生成图像：[描述]'为你的项目生成图像",
      "🔍 解释如何使用Scratch积木和功能",
      "💡 建议项目创意和创造性解决方案"
    ],
    tryPrompt: "试着问：'如何让角色移动？'或'生成图像：一个友好的机器人'",
    langNote: "你可以使用上方的地球图标更改语言！"
  },
  ar: {
    title: "👋 مرحبًا بك في Cognimates Copilot!",
    description: "أنا مساعدك البرمجي بالذكاء الاصطناعي جاهز لمساعدتك في مشاريع سكراتش. إليك ما يمكنني فعله:",
    features: [
      "💬 الإجابة على أسئلة حول مفاهيم البرمجة",
      "🎨 إنشاء صور لمشاريعك باستخدام 'إنشاء صورة: [الوصف]'",
      "🔍 شرح كيفية استخدام كتل سكراتش وميزاتها",
      "💡 اقتراح أفكار للمشاريع وحلول إبداعية"
    ],
    tryPrompt: "جرب أن تسأل: 'كيف أجعل الكائن يتحرك؟' أو 'إنشاء صورة: روبوت ودود'",
    langNote: "يمكنك تغيير اللغة باستخدام أيقونة الكرة الأرضية أعلاه!"
  },
  hi: {
    title: "👋 Cognimates Copilot में आपका स्वागत है!",
    description: "मैं आपका AI कोडिंग सहायक हूँ, जो स्क्रैच प्रोजेक्ट्स में मदद करने के लिए तैयार हूँ। मैं यह कर सकता हूँ:",
    features: [
      "💬 प्रोग्रामिंग अवधारणाओं के बारे में प्रश्नों के उत्तर देना",
      "🎨 'छवि बनाएँ: [विवरण]' के साथ आपके प्रोजेक्ट्स के लिए छवियाँ उत्पन्न करना",
      "🔍 स्क्रैच ब्लॉक्स और सुविधाओं का उपयोग कैसे करें, यह समझाना",
      "💡 प्रोजेक्ट विचार और रचनात्मक समाधान सुझाना"
    ],
    tryPrompt: "यह पूछने की कोशिश करें: 'मैं स्प्राइट को कैसे हिलाऊं?' या 'छवि बनाएँ: एक मित्रवत रोबोट'",
    langNote: "आप ऊपर दिए गए ग्लोब आइकन का उपयोग करके भाषा बदल सकते हैं!"
  }
};

// Create a named object before exporting it as default
const uiLocalization = {
  getLocalizedText,
  // Export key command patterns directly
  generateImageCommand: "generate image",
  // Add welcome messages
  welcomeMessages
};

export default uiLocalization;
